/* eslint-disable */
import React from 'react'
import {Button, Icon, message, Tabs, Upload} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import cookie from 'react-cookies'
import pdfUrl from '../../Component/BaseComponent/pdfUrl'
import jMoment from 'moment-jalaali'
const TabPane = Tabs.TabPane

const token = sessionStorage.getItem('accessToken')

const props = {
  name: 'picture',
  token: sessionStorage.getItem('accessToken'),
  action: pdfUrl + 'user/profile/update/picture',
  headers: {
    CSN: '100000000000000',
    CTY: 'B',
    Authorization: `Bearer ${token}`
  },
  onChange(info) {
    if (info.file.status !== 'uploading') {
      console.log(info.file, info.fileList)
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} بارگزاری عکس موفق آمیز بود.`)
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} عکس با موفقیت بارگزاری نشد`)
    }
  }
}

class Profile extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabPosition: 'right',
      firstnamelabel: '',
      firstname: '',
      lastnamelabel: '',
      lastname: '',
      addresslabel: '',
      mobilelabel: '',
      mobile: '',
      emaillabel: '',
      changePasswordError: '',
      oldPassword: '',
      newPassword: '',
      repeatNewPassword: '',
      error: ''
    }
  }

  changeTabPosition = (tabPosition) => {
    this.setState({tabPosition})
  }

  componentDidMount() {
    if (cookie.load('accessToken')) {
      const token = sessionStorage.getItem('accessToken')

      http
        .get(`user/profile/show`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then((response) => {
          // alert(JSON.stringify(response.data))
          const BaseURLPIC = 'http://185.13.228.98:808/Beroozresan/images/'
          this.setState({
            firstnamelabel: response.data.object.firstname,
            lastnamelabel: response.data.object.lastname,
            addresslabel: response.data.object.address,
            mobilelabel: response.data.object.mobile,
            emaillabel: response.data.object.email,
            phonelabel: response.data.object.phone,
            picture: BaseURLPIC + response.data.object.picture
          })
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  changeField(e) {
    const target = e.target
    const value = target.value
    const name = target.name

    if (!(value === null)) {
      this.setState({
        [name]: value
      })
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  changePassword() {
    var oldPassword = this.convertDigit(document.getElementById('oldPassword').value)
    var newPassword = this.convertDigit(document.getElementById('newPassword').value)
    var repeatNewPassword = this.convertDigit(document.getElementById('repeatNewPassword').value)
    var oldPassError = false
    var newPassError = false
    var reNewPassError = false
    var passFormError = false
    var repeatError = false
    if (oldPassword == '') {
      message.error('کلمه عبور قدیم را وارد کنید')
      oldPassError = true
      passFormError = true
    } else {
      if (!oldPassError) {
        this.setState({error: ''})
      }
    }
    if (newPassword == '') {
      message.error('کلمه عبور جدید را وارد کنید')
      newPassError = true
      passFormError = true
    } else if (newPassword.length < 6) {
      message.error('کلمه عبور جدید باید حداقل 6 کاراکتر باشد')
      newPassError = true
      passFormError = true
    } else {
      if (!newPassError) {
        this.setState({error: ''})
      }
    }
    if (repeatNewPassword != newPassword) {
      message.error('کلمه عبور جدید با تکرار آن مطابقت ندارد')
      repeatError = true
      passFormError = true
    } else {
      if (!repeatError) {
        this.setState({error: ''})
      }
    }

    if (repeatNewPassword == '') {
      reNewPassError = true
      passFormError = true
      message.error('تکرار کلمه عبور جدید را وارد کنید')
    } else {
      if (!reNewPassError) {
        this.setState({error: ''})
      }
    }

    if (!passFormError) {
      const token = sessionStorage.getItem('accessToken')
      const data = {
        oldPassword: oldPassword,
        newPassword: newPassword
      }

      http
        .post(`user/profile/update/password`, data, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then((response) => {
          if (response.data.error === null) {
            message.success('کلمه عبور با موفقیت تغییر کرد')
          } else {
            message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  EditInfo() {
    var firstname = document.getElementById('name').value
    var lastname = document.getElementById('lastname').value
    var mobile = this.convertDigit(document.getElementById('mobile').value)
    var email = document.getElementById('email').value
    var phone = this.convertDigit(document.getElementById('phone').value)
    var address = document.getElementById('address').value
    var nationalId = document.getElementById('nationalId').value
    var father = document.getElementById('father').value
    var birthday = document.getElementById('birthday').value
    var cityId = document.getElementById('cityId').value
    var zipCode = document.getElementById('zipCode').value
    var firstnameError = false
    var lastnameError = false
    var mobileError = false
    var emailError = false
    var birthDayError = false
    var formError = false
    if (firstname == '') {
      firstnameError = true
      formError = true
      message.error('نام را وارد کنید')
    } else {
      if (!firstnameError) {
        this.setState({error: ''})
      }
    }
    if (lastname == '') {
      lastnameError = true
      formError = true
      message.error('نام خانوادگی را وارد کنید')
    } else {
      if (!lastnameError) {
        this.setState({error: ''})
      }
    }

    if (
      birthday !== '' &&
      !birthday.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/g
      )
    ) {
      birthDayError = true
      formError = true
      message.error('فرمت تولد صحیح وارد شود')
    } else {
      if (!birthDayError) {
      }
    }

    if (mobile == '') {
      mobileError = true
      formError = true
      message.error('موبایل را وارد کنید')
    } else if (!mobile.match(/^09\d{9}$/g)) {
      mobileError = true
      formError = true
      message.error('موبایل را صحیح وارد کنید.مثال : 09124444444')
    } else {
      if (!mobileError) {
        this.setState({error: ''})
      }
    }
    if (
      !(email == '') &&
      !email.match(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/g
      )
    ) {
      emailError = true
      formError = true
      message.error('ایمیل را صحیح وارد کنید')
    } else {
      if (!emailError) {
        this.setState({error: ''})
      }
    }

    if (!formError) {
      let data = {
        firstname: firstname,
        lastname: lastname,
        mobile: mobile,
        email: email == '' ? undefined : email,
        phone: phone == '' ? undefined : phone,
        address: address == '' ? undefined : address,
        nationalId: nationalId == '' ? undefined : nationalId,
        father: father == '' ? undefined : father,
        birthday:
          birthday == '' ? undefined : this.convertDigit(jMoment(birthday, 'jYYYY/jMM/jDD').format('YYYY/MM/DD')),
        cityId: cityId == '' ? undefined : cityId,
        zipCode: zipCode == '' ? undefined : zipCode
      }
      http.post(`user/profile/update/info`, data, {}).then((response) => {
        if (response.data.error == null) {
          message.success('ویرایش مشخصات با موفقیت انجام شد')
        } else {
          message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
    }
  }

  changeEditField(e) {
    const target = e.target
    const value = target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  render() {
    return (
      <div className="rtl">
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <div className="profileInfo">
            <div className="avatar">
              <div className="imageProfile">
                <img src={this.state.picture} alt="" />
              </div>

              <Upload {...props}>
                <Button>
                  <Icon type="upload" />
                  عکس پروفایل جدید
                </Button>
              </Upload>
              <p>نام : {this.state.firstnamelabel}</p>
              <p>نام خانوادگی : {this.state.lastnamelabel}</p>
              <p>ایمیل : {this.state.emaillabel}</p>
              <p>موبایل : {this.state.mobilelabel}</p>
              <p>آدرس : {this.state.addresslabel}</p>
              <p>تلفن : {this.state.phonelabel}</p>
            </div>

            <div className="tabInfo">
              <div>
                <Tabs tabPosition={this.state.tabPosition}>
                  <TabPane
                    tab={
                      <span>
                        <Icon type="edit" theme="twoTone" />
                        ویرایش اطلاعات
                      </span>
                    }
                    key="1"
                  >
                    <form onSubmit={this.submitForm.bind(this)} className="editInfoForm">
                      <div>
                        <label for="name">
                          نام<span className="requireFiled">*</span>
                        </label>
                        <input
                          type="text"
                          defaultValue={this.state.firstnamelabel}
                          name="firstname"
                          id="name"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                        <label for="lastname">
                          نام خانوادگی<span className="requireFiled">*</span>
                        </label>
                        <input
                          type="text"
                          defaultValue={this.state.lastnamelabel}
                          name="lastname"
                          id="lastname"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                        <label for="mobile">
                          شماره موبایل<span className="requireFiled">*</span>
                        </label>
                        <input
                          type="text"
                          defaultValue={this.state.mobilelabel}
                          id="mobile"
                          name="mobile"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                        <label for="mobile" className="hiddenLabel">
                          شماره موبایل(الزامی)
                        </label>

                        <button className="btn btn-primary form-control" onClick={this.EditInfo.bind(this)}>
                          اعمال تغییرات
                        </button>
                        <p className="errorText">{this.state.errorEditForm}</p>
                      </div>
                      <div>
                        <label for="email">ایمیل</label>
                        <input
                          type="email"
                          id="email"
                          defaultValue={this.state.emaillabel}
                          name="email"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                        <label for="phone">تلفن ثابت</label>
                        <input
                          type="text"
                          id="phone"
                          defaultValue={this.state.phonelabel}
                          name="phone"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                        <label for="address">آدرس</label>
                        <textarea
                          id="address"
                          name="address"
                          defaultValue={this.state.addresslabel}
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                        <label for="nationalId">کد ملی</label>
                        <input
                          type="text"
                          id="nationalId"
                          name="nationalId"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                      </div>
                      <div>
                        <label for="father">نام پدر</label>
                        <input
                          type="text"
                          name="father"
                          id="father"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                        <label for="birthday">تاریخ تولد</label>
                        <input
                          type="text"
                          id="birthday"
                          name="birthday"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                        <label for="cityId">شهر</label>
                        <input
                          type="text"
                          id="cityId"
                          name="cityId"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                        <label for="zipCode">کد پستی</label>
                        <input
                          type="text"
                          id="zipCode"
                          name="zipCode"
                          className="form-control"
                          onChange={this.changeEditField.bind(this)}
                        />
                      </div>
                    </form>
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <Icon type="mail" theme="twoTone" />
                        پیام ها
                      </span>
                    }
                    key="2"
                  >
                    <div className="commentWrapp">
                      <div className="image">
                        <img src={require('../../image/userCm.svg')} alt="" />
                      </div>
                      <div className="pm">
                        <p>ارسالی از عرفان :</p>
                        <p>لورم ایپسوم یک متن ساختگیست که معنا و مفهوم حاصی ندارد و نمایانگر</p>
                      </div>
                      <div className="hourPm">
                        <p>12:30</p>
                      </div>
                    </div>
                    <div className="commentWrapp">
                      <div className="image">
                        <img src={require('../../image/userCm.svg')} alt="" />
                      </div>
                      <div className="pm">
                        <p>ارسالی از عرفان :</p>
                        <p>لورم ایپسوم یک متن ساختگیست که معنا و مفهوم حاصی ندارد و نمایانگر</p>
                      </div>
                      <div className="hourPm">
                        <p>12:30</p>
                      </div>
                    </div>
                    <div className="commentWrapp">
                      <div className="image">
                        <img src={require('../../image/userCm.svg')} alt="" />
                      </div>
                      <div className="pm">
                        <p>ارسالی از عرفان :</p>
                        <p>لورم ایپسوم یک متن ساختگیست که معنا و مفهوم حاصی ندارد و نمایانگر</p>
                      </div>
                      <div className="hourPm">
                        <p>12:30</p>
                      </div>
                    </div>
                  </TabPane>
                  <TabPane
                    tab={
                      <span>
                        <Icon type="tool" theme="twoTone" />
                        تغییر رمز
                      </span>
                    }
                    key="3"
                  >
                    <form onSubmit={this.submitForm.bind(this)} className="editInfoForm">
                      <div>
                        <label for="oldPassword">
                          کلمه عبور کنونی<span className="requireFiled">*</span>
                        </label>
                        <input
                          type="password"
                          id="oldPassword"
                          name="oldPassword"
                          className="form-control"
                          onChange={this.changeField.bind(this)}
                        />
                        <label for="." className="hiddenLabel">
                          /
                        </label>
                        <button
                          className="editForm form-control btn btn-primary"
                          onClick={this.changePassword.bind(this)}
                        >
                          اعمال تغییرات
                        </button>
                        <p className="errorText">{this.state.changePasswordError}</p>
                      </div>
                      <div>
                        <label for="newPassword">
                          کلمه عبور جدید<span className="requireFiled">*</span>
                        </label>
                        <input
                          type="password"
                          id="newPassword"
                          name="newPassword"
                          className="form-control"
                          onChange={this.changeField.bind(this)}
                        />
                      </div>
                      <div>
                        <label for="repeatNewPassword">
                          تکرار کلمه عبور جدید<span className="requireFiled">*</span>
                        </label>
                        <input
                          type="password"
                          id="repeatNewPassword"
                          name="repeatNewPassword"
                          className="form-control"
                          onChange={this.changeField.bind(this)}
                        />
                      </div>
                    </form>
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Profile
